// extracted by mini-css-extract-plugin
export default {"focusedBlockDataContainer":"focusedBlockData_focusedBlockDataContainer__4Rskb","date":"focusedBlockData_date__hZyYE","reward":"focusedBlockData_reward__oa1bU"};